var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-range-picker',{attrs:{"appendToBody":true,"opens":'right',"locale-data":{
		firstDay: 1,
		format: 'dd mmm yyy',
		applyLabel: _vm.$t('label.apply'),
		cancelLabel: _vm.$t('label.cancel'),
	}},scopedSlots:_vm._u([{key:"input",fn:function(picker){return [_c('v-text-field',{attrs:{"label":"Date","tile":"","dense":"","readonly":"","value":_vm.moment(picker.startDate) + ' - ' + _vm.moment(picker.endDate)}})]}}]),model:{value:(_vm.filter.range),callback:function ($$v) {_vm.$set(_vm.filter, "range", $$v)},expression:"filter.range"}})
}
var staticRenderFns = []

export { render, staticRenderFns }